//
//
//
//

export default {
  props: {
    value: {
      default: ''
    }
  },
  methods: {
    clickEvent () {
      this.$emit('click')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/simple/appButton/App-button.vue